import React from 'react';
import { Link } from 'react-router-dom'; // Import Link from react-router-dom
import { Autoplay, Navigation, Pagination } from 'swiper/modules';
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css';
import 'swiper/css/autoplay';
import 'swiper/css/navigation';
import 'swiper/css/pagination';

import ContainerShear from '../../assets/images/services/container-shear-12.png';
import HydraulicScrapBaler from '../../assets/images/services/hydraulic-scrap-baler.png';
import HeavyDutyScrapShear from '../../assets/images/services/heavy-duty-scrap-shear.png';
import Excavator from '../../assets/images/services/excavator.png';
import Magnet from '../../assets/images/services/MAGNET.png';
import VerticalScrapShear from '../../assets/images/services/vertical-scrap-shear.png';
import Fixboom from '../../assets/images/services/fixboom.png';
import DoubleShaft from '../../assets/images/services/double-shaft-shredder.png'
import Grab from '../../assets/images/services/GRAB.png';
// Swiper options
const swiperOptions = {
  modules: [Autoplay, Pagination, Navigation],
  slidesPerView: 2,
  spaceBetween: 30,
  speed: 2000,
  autoplay: {
    delay: 9000,
    disableOnInteraction: false,
  },
  loop: true,
  navigation: {
    nextEl: '.swiper-button-next1',
    prevEl: '.swiper-button-prev1',
  },
  pagination: {
    el: '.swiper-dot-style1',
    type: 'bullets',
    clickable: true,
  },
  breakpoints: {
    0: {
      spaceBetween: 0,
      slidesPerView: 1,
    },
    375: {
      spaceBetween: 30,
      slidesPerView: 1,
    },
    575: {
      spaceBetween: 30,
      slidesPerView: 1,
    },
    768: {
      spaceBetween: 30,
      slidesPerView: 1,
    },
    992: {
      spaceBetween: 30,
      slidesPerView: 2,
    },
    1200: {
      spaceBetween: 30,
      slidesPerView: 3,
    },
    1320: {
      spaceBetween: 30,
      slidesPerView: 3,
    },
  },
};

// Sample service data
const services = [
  {
    imgName: ContainerShear,
    title: 'HORIZONTAL AUTOMATIC CONTAINER SHEARING MACHINE',
    link: '/horizontal-automatic-container-shear',
    description: 'Horizontal Automatic Container Shearing Machine is ideal for cutting the metal shaped in different...',
  },
  {
    imgName: HydraulicScrapBaler,
    title: 'HYDRAULIC SCRAP BALER',
    link: '/hydraulic-scrap-baler',
    description: 'Hydraulic Scrap Baler is ideal for cutting the metal shaped in different cross sections...',
  },
  // {
  //   imgName: HeavyDutyScrapShear,
  //   title: 'HEAVY DUTY SCRAP SHEAR',
  //   link: '/peak-performance-roofing',
  //   description: 'Heavy-duty scrap shear is a dynamic and heavy duty multi-tasking machine.',
  // },
  // {
  //   imgName: Excavator,
  //   title: 'MOVABLE EXCAVATOR',
  //   link: '/movable-excavator',
  //   description: 'An excavator is a heavy-duty machine that is primarily used for loading large amounts....',
  // },
  {
    imgName: Magnet,
    title: 'SCRAP MAGNET',
    link: '/scrap-magnet',
    description: 'A scrap magnet, also referred to as a scrap metal magnet, is a specialized electromagnet...',
  },
  {
    imgName: VerticalScrapShear,
    title: 'VERTICAL HEAVY DUTY SCRAP SHEARING MACHINE',
    link: '/vertical-scrap-shear',
    description: 'A Vertical Heavy Duty Scrap Shearing machine is a robust and powerful machine ....',
  },
  // {
  //   imgName: Fixboom,
  //   title: 'FIXED BOOM EXCAVATOR',
  //   link: '/fixed-boom-excavator',
  //   description: 'This type of fixed boom excavator is frequently used to feed scrap shear machines beneath...',
  // },
  {
    imgName: DoubleShaft,
    title: 'DOUBLE SHAFT SCRAP SHREDDER',
    link: '/double-shaft-shredder',
    description: 'A double shaft scrap shredder is a powerful industrial machine designed to shred various matierals ...',
  },
];

export default function ServicesOne() {
  return (
    <section className="services-one">
      <div className="container">
        <div className="section-title text-center">
          <div className="section-title__tagline-box">
            <span className="section-title__tagline">Latest Machines</span>
          </div>
          <h2 className="section-title__title">
            Explore Our <span>Wide </span>Range of <span> Products</span>
            {/* Our  <span>Products</span> */}
          </h2>
        </div>
        <div className="services-one__carousel">
          <Swiper {...swiperOptions}>
            {services.map((service, index) => (
              <SwiperSlide key={index}>
                <Link to={service.link}> <div className="services-one__single border " style={{ color: "#52515E", borderRadius: '20px' }}>
                  <div className="services-one__img-box">
                    <div className="services-one__img">
                      <img
                        src={`${service.imgName}`}
                        alt={service.title}
                      />
                    </div>
                    <div className="services-one__icon">
                      <span className="icon-paint"></span>
                    </div>
                  </div>
                  <div className="services-one__content">
                    <h3 className="services-one__title">
                      <Link to={service.link}>{service.title}</Link>
                    </h3>
                    <p className="services-one__text">{service.description}</p>
                    <div className="services-one__btn-box">
                      <Link to={service.link} className="services-one__btn thm-btn">
                        Read more
                        <span className="icon-dubble-arrow-right"></span>
                      </Link>
                    </div>
                  </div>
                </div>
                </Link>
              </SwiperSlide>
            ))}
          </Swiper>
        </div>
        {/* Navigation Buttons */}
        {/* Pagination */}
      </div>
    </section>
  );
}
